var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoCarrocaria2Pt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "18px",
    viewBox: "0 0 42 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Picto Carro\xE7aria &gt; 2pt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PICTOGRAMAS-CATEGORIES",
    transform: "translate(-271.000000, -409.000000)",
    stroke: "#00A9FD",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picto-Carro\\xE7aria->-2pt",
    transform: "translate(272.000000, 410.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    points: "26.5389873 6.18168776 24.9881013 7.03783605 11.5941772 7.03783605 9.69088608 5.11188668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4294177,15.8830621 L27.2213165,15.8830621",
    id: "Stroke-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39306329,15.8830621 C4.39306329,13.637402 6.19205063,11.8169982 8.41129114,11.8169982 C10.6305316,11.8169982 12.429519,13.637402 12.429519,15.8830621",
    id: "Stroke-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.221519,15.8830621 C27.221519,13.637402 29.0205063,11.8169982 31.2397468,11.8169982 C33.4589873,11.8169982 35.2579747,13.637402 35.2579747,15.8830621",
    id: "Stroke-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1980759,15.8830621 L39.6507342,15.8830621 L39.6507342,10.3188668 C39.6507342,10.3188668 36.1261772,5.46838457 29.2178228,5.46838457 C29.2178228,5.46838457 26.1160506,1.04572031 21.1813671,0.0471368294 L12.0173165,0.0471368294 C12.0173165,0.0471368294 8.49225316,0.617902351 3.55807595,5.32594937 L0.879088608,5.32594937 C0.879088608,5.32594937 0.0330126582,6.75235081 0.0330126582,11.3179626 C0.0330126582,11.3179626 -0.531037975,15.8830621 2.99402532,15.8830621 L4.33326582,15.8830621",
    id: "Stroke-8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoCarrocaria2Pt);
export default __webpack_public_path__ + "static/media/PictoCarrocaria_2pt.c425d86f06789bd65ee205c5d606e846.svg";
export { ForwardRef as ReactComponent };